export const BRAND = "Lead ITES";
export const TAGLINE = "Connecting Technology, Business & Growth.";

export const CATEGORIES = [
  "Technology",
  "AI",
  "Cybersecurity",
  "Cloud",
  "Data & Analytics",
  "Marketing Technology",
  "Sales",
  "Business",
  "Digital Transformation",
  "Software",
];

// Top navigation (maps the requested nav to routes)
export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Technology", to: "/articles?category=Technology" },
  { label: "Business", to: "/articles?category=Business" },
  { label: "Marketing", to: "/articles?category=Marketing%20Technology" },
  { label: "AI & Data", to: "/articles?category=AI" },
  { label: "Cybersecurity", to: "/articles?category=Cybersecurity" },
  { label: "Research & Reports", to: "/reports" },
  { label: "Business Solutions", to: "/solutions" },
  { label: "Lead Generation", to: "/lead-generation" },
  { label: "Partnerships", to: "/partnerships" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

// Condensed set shown directly on desktop; the rest live in "Topics" + mobile menu
export const PRIMARY_NAV = [
  { label: "Research & Reports", to: "/reports" },
  { label: "Business Solutions", to: "/solutions" },
  { label: "Lead Generation", to: "/lead-generation" },
  { label: "Partnerships", to: "/partnerships" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];
